import React, { ReactElement } from 'react'
import { OrganizationCreatePage } from 'src/ui/page/common/organization/details/OrganizationCreatePage'

export const ServicePartnerCreatePage = (): ReactElement => {
  return <OrganizationCreatePage isServicePartner />
}
